import { constVoid, DOM, IOO, O, pipe, s } from '@packages/prelude'
import { Swiper, Navigation, Pagination } from 'swiper'

import 'bootstrap'
import '../css/main.scss'

pipe(
  IOO.of({ window }),
  IOO.chainFirst(({ window: { document } }) =>
    pipe(
      document,
      DOM.querySelector('.swiper'),
      IOO.map(swiper => initSwiper(swiper as HTMLElement))
    )
  )
)()

function initSwiper(swiper: HTMLElement) {
  new Swiper(swiper, {
    direction: 'horizontal',
    speed: 750,
    modules: [Pagination, Navigation],
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  })
}

pipe(
  IOO.of({ document }),
  IOO.bind('announcementButton', ({ document }) => pipe(document, DOM.querySelector('.remove-announcement'))),
  IOO.bind('announcement', ({ document }) => pipe(document, DOM.querySelector('.announcement'))),
  IOO.map(({ announcementButton, announcement }) => {
    pipe(
      sessionStorage.getItem('announcementDisplay'),
      O.fromNullable,
      O.chain(O.fromPredicate(session => s.Eq.equals(session, 'false'))),
      O.fold(
        () => {
          announcement.classList.add('show')
        },
        () => constVoid
      )
    )
    DOM.addEventListener('click')(e => () => {
      e.preventDefault()
      sessionStorage.setItem('announcementDisplay', 'false')
      announcement.classList.remove('show')
    })(announcementButton)()
  })
)()
